export default __webpack_public_path__ + "static/media/mysteryBetLogo.483e16bf.png";